export default __webpack_public_path__ + "e0b2f2ae2bb6b33c563662154fa1f2c0.svg";